import { Grouping } from "@devexpress/dx-react-grid";
import { OrderListState, UpdateOrdersActionPayload } from "./rootReducerTypes";
import {
    OrderListActionTypes, UPDATE_ORDERS, REQUEST_ERROR, FETCH_INIT, SET_CURRENT_PAGE, UPDATE_QUERY, SetPageSizeAction, SET_PAGE_SIZE, UPDATE_SHOW_HISTORICAL, UpdateSortByAction, UPDATE_SORTBY, UPDATE_TOTAL_COUNT_BY_ORDER_STATUS, UpdateTotalCountByOrderStatus, UPDATE_SEARCH_ORDERS, UpdateSearchOrdersAction, ChangeGroupingAction, CHANGE_GROUPING, SetExpandedGroupsAction, SET_EXPANDED_GROUPS,
    UpdateOrdersAction
    , RequestErrorAction
    , FetchInitAction
    , SetCurrentPageAction
    , UpdateQueryAction
    , UpdateShowHistoricalAction
} from './orderListActionAndReducerTypes';
import { OrderStatusCount } from '../Interfaces';

// #region actions
export function updateOrders(updateOrdersActionPayload: UpdateOrdersActionPayload): UpdateOrdersAction {
    return {
        type: UPDATE_ORDERS,
        updateOrdersActionPayload,
    };
}

export function requestError(): RequestErrorAction {
    return {
        type: REQUEST_ERROR,
    };
}
export function fetchInit(): FetchInitAction {
    return {
        type: FETCH_INIT,
    };
}
export function setCurrentPage(currentPage: number): SetCurrentPageAction {
    return {
        type: SET_CURRENT_PAGE,
        currentPage
    };
}
export function setPageSize(pageSize: number): SetPageSizeAction {
    return {
        type: SET_PAGE_SIZE,
        pageSize
    };
}
export function updateQuery(lastQuery: string): UpdateQueryAction {
    return {
        type: UPDATE_QUERY,
        lastQuery
    };
}

export function updateShowHistorical(showHistorical: boolean): UpdateShowHistoricalAction {
    return {
        type: UPDATE_SHOW_HISTORICAL,
        showHistorical
    };
}

export function updateSortBy(payload: string): UpdateSortByAction {
    return {
        type: UPDATE_SORTBY,
        sortBy: payload
    };
}

export function updateTotalCountByOrderStatus(payload: OrderStatusCount): UpdateTotalCountByOrderStatus {
    return {
        type: UPDATE_TOTAL_COUNT_BY_ORDER_STATUS,
        totalCountByOrderStatus: payload
    };
}

export function updateSearchOrders(payload: string): UpdateSearchOrdersAction {
    return {
        type: UPDATE_SEARCH_ORDERS,
        searchText: payload
    };
}

export function changeGrouping(payload: Grouping[]): ChangeGroupingAction {
    return {
        type: CHANGE_GROUPING,
        grouping: payload
    };
}

export function setExpandedGroups(payload: string[]): SetExpandedGroupsAction {
    return {
        type: SET_EXPANDED_GROUPS,
        expandedGroups: payload
    };
}

// #end region actions

export default function orderListReducer(state: OrderListState = initialState, action: OrderListActionTypes): OrderListState {
    switch (action.type) {
        case 'UPDATE_ORDERS':
            return {
                ...state,
                orders: action.updateOrdersActionPayload.orders,
                totalCount: action.updateOrdersActionPayload.totalCount,
                totalGroupCount: action.updateOrdersActionPayload.totalGroupCount ? action.updateOrdersActionPayload.totalGroupCount : state.totalGroupCount,
                skip: action.updateOrdersActionPayload.skip ? action.updateOrdersActionPayload.skip : state.skip,
                groupChildrenSkip: action.updateOrdersActionPayload.groupChildrenSkip ? action.updateOrdersActionPayload.groupChildrenSkip : state.groupChildrenSkip,
                loading: false,
                tempGrouping: null,
                tempExpandedGroups: null,
            };
        case 'REQUEST_ERROR':
            return {
                ...state,
                loading: false,
            };
        case 'FETCH_INIT':
            return {
                ...state,
                loading: true,
            };
        case 'SET_CURRENT_PAGE':
            return {
                ...state,
                currentPage: action.currentPage,
                skip: action.currentPage * state.pageSize,
                groupChildrenSkip: state.expandedGroups.length > 0 ? action.currentPage * state.pageSize : 0
            };
        case 'UPDATE_QUERY':
            return {
                ...state,
                lastQuery: action.lastQuery,
            };
        case 'SET_PAGE_SIZE':
            return {
                ...state,
                pageSize: action.pageSize,
            };
        case 'UPDATE_SHOW_HISTORICAL':
            return {
                ...state,
                showHisorical: action.showHistorical,
            };
        case 'UPDATE_SORTBY':
            return {
                ...state,
                sortBy: action.sortBy,
            };
        case 'UPDATE_TOTAL_COUNT_BY_ORDER_STATUS':
            return {
                ...state,
                totalCountByOrderStatus: action.totalCountByOrderStatus,
            };
        case 'UPDATE_SEARCH_ORDERS':
            return {
                ...state,
                searchText: action.searchText,
            };
        case 'CHANGE_GROUPING':
            return {
                ...state,
                grouping: action.grouping,
                tempGrouping: state.tempGrouping === null ? state.grouping : state.tempGrouping,
                tempExpandedGroups: state.expandedGroups,
            };
        case 'SET_EXPANDED_GROUPS':
            return {
                ...state,
                expandedGroups: action.expandedGroups,
                totalCount: action.expandedGroups.length === 0 && state.grouping.length > 0 ? state.totalGroupCount : state.totalCount,
                groupChildrenSkip: 0
            };
        default:
            return state;
    }
}

export const initialState: OrderListState = {
    orders: [],
    skip: 0,
    totalCount: 0,
    totalGroupCount: 0,
    loading: false,
    lastQuery: '',
    currentPage: 0,
    pageSize: 50,
    showHisorical: false,
    snackBar: { isShow: false, message: '', severity: undefined },
    sortBy: '',
    searchText: '',
    totalCountByOrderStatus: { newCount: 0, ongoingCount: 0, finishedCount: 0, receivedCount: 0 },
    grouping: [],
    expandedGroups: [],
    tempGrouping: null,
    tempExpandedGroups: null,
    groupChildrenSkip: 0
};